import React, { useEffect, useMemo, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { ProductAction, AuthAction } from '../../actions';
import {
	ProductInfo,
	ProductInfoACQ,
	ProductComments,
	ProductDelete,
	ProductInfoSite,
	ProductInfoWaranty,
} from '../../components/product'
import { CalendarConstant } from '../../actions/constants/CalendarConstant';
import ProductErrorList from '../../components/product/ProductErrorList';
import { ProductStatus } from '../../components/product/ProductStatus';
import { AppHeader } from '../../components/common';
import { isDOA, isDIM } from '../../components/common/CommonViews';
import ScheduleCreate from '../../components/schedule/ScheduleCreate';
import { DEFAULT_SCHEDULE_HOURS } from '../../config/scheduleDefaults';
import ProductErrorCard from '../../components/product/ProductErrorCard';
import { NoRecord } from '../../pages/HomePage';
import moment from 'moment';
import ProductInfoServices from '../../components/product/ProductInfoServices';
import ProductInfoErrorChart from '../../components/product/ProductInfoErrorChart';
import ProductDIM from '../../components/product/ProductDIM';
import ProductDOA from '../../components/product/ProductDOA';
import { hasEditableProductField } from '../../components/product/ProductInfo';
import { Translate as t } from '../../config/Translate';
import { Loading } from '../../components/common/Loading';

const ProductView = ({ GetProduct, UpdateUserFav, productData, favList, _sn, showChart, showSub, chartType, user }) => {

	const dispatch = useDispatch();
	const [showAS, setShowAS] = useState(false);
	const { sn, view } = useParams();
	const [maintab, setMainTab] = useState(view || "info");
	const [isLoading, setIsLoading] = useState(true);
	const [editable, setEditable] = useState(false);
	const [errList, setErrList] = useState([]);
	const [isFav, setIsFav] = useState(false);
	const [product, setProduct] = useState({});
	const [showDIADOA, setshowDIADOA] = useState("COMMENT");

	// U-27: 대상 장비(주소의 sn 또는 지도 패널의 _sn)와 일치하는 응답만 화면에 쓴다.
	// redux 에 남은 직전 장비가 없는 주소에서 그대로 보이던 문제 차단 (ServiceDetail 게이트와 같은 방식).
	const targetSn = _sn || sn;
	const [fetchDone, setFetchDone] = useState(false);
	const isTarget = (p) => !!targetSn && !!p?.sn && String(p.sn).toLowerCase() === String(targetSn).toLowerCase();
	const hasProduct = isTarget(product);
	// U-12: Tech 화면에서 고칠 칸이 하나도 없는 사용자에게는 연필을 숨긴다 (판정은 ProductInfo 와 공용).
	const canEditProduct = useMemo(() => hasEditableProductField(user, false), [user]);

	useEffect(() => {
		setIsLoading(false)
		getErrList();
		setIsFav(favList ? favList.includes(product.sn) : false);
	}, [product])

	useEffect(() => {
		if (isTarget(productData)) {
			setProduct(productData);
		}
	}, [productData, targetSn])

	useEffect(() => {
		setIsFav(favList ? favList.includes(product.sn) : false);
	}, [favList])

	useEffect(() => {
		if (!targetSn) return undefined;
		let alive = true;
		setFetchDone(false);
		setProduct((prev) => (isTarget(prev) ? prev : {}));
		// thunk 는 내부 try/catch 로 처리하므로 여기 catch 는 unhandled rejection 차단용.
		Promise.resolve(GetProduct(targetSn)).catch(() => { }).finally(() => {
			if (alive) setFetchDone(true);
		});
		return () => { alive = false; };
	}, [targetSn])

	const mainTabList = [
		{ code: "info", title: t("common.label.overview"), icon: "info" },
		{ code: "service", title: t('service.title'), icon: "visibility" },
		{ code: "error", title: t('common.label.error'), icon: "info" },
		{ code: "acquisition", title: t('product.label.acquisition'), icon: "visibility" },
		//{ code : "sch", title : "Schedule", icon : "visibility" },
	]

	const removeArr = (id) => {
		const idx = favList.indexOf(id);
		if (idx > -1) {
			favList.splice(idx, 1);
		}
		return favList;
	}

	const fav = () => {
		UpdateUserFav("sn", isFav ?
			{ favorites: removeArr(product.sn) } :
			{ favorites: [...favList, product.sn] });
	}
	const getErrList = () => {
		const list = [];
		if (product.errs) {
			product.errs.map(x => {
				list.push({ ...product, errs: x, acquisition: [] });
			});
		}
		setErrList(list.sort((a, b) => b.errs.begin - a.errs.begin));
	}

	const setSchedule = () => {
		dispatch({
			type: CalendarConstant.SET_NEW, item: {
				type: "On-site",
				color: "bg-success",
				start: moment().clone().add(4, "hours").valueOf(),
				finish: moment().clone().add(4 + DEFAULT_SCHEDULE_HOURS, "hours").valueOf(),
				sn: product.sn,
				sitename: product.sitename,
				siteId: product.siteId,
				model: product.model,
				option: product.option
			}
		});
		setShowAS(true);
	}

	const isOnline = () => {
		return product.isConnected ?
			<ion-icon name="wifi" className="text-primary md hydrated"></ion-icon> :
			<ion-icon name="wifi-outline" className="text-muted md hydrated"></ion-icon>;
	}

	const [height, setvHg] = useState(300);
	const [width, setvWh] = useState(800);
	const getHeight = () => setvHg(window.innerHeight);
	const getWidth = () => setvWh(window.innerWidth);
	useEffect(() => {
		window.addEventListener('resize', getHeight);
		window.addEventListener('resize', getWidth);
		setvHg(window.innerHeight);
		setvWh(window.innerWidth);
	}, [])

	const sortErr = (errs) => errs.sort((a, b) => a.begin > b.begin ? 1 : -1);

	const getScrollHeight = () => {
		let min = 72 + 72;
		if (showChart && ChartHasVal())
			min += 310;
		if (showSub)
			min += 72;
		return height - min;
	}

	const ChartHasVal = () => {
		if (chartType == "acq" && product.acquisitions) {
			return product.acquisitions.filter(x => x.activationTime > moment().add(-1 * 60, 'days')).length > 0;
		}
		if (chartType == "err" && product.errs) {
			return product.errs.filter(x => x.begin > moment().add(-1 * 60, 'days')).length > 0;
		}
		return false;
	}

	// U-27: 대상 장비가 아직 없거나(로딩) 없는 주소(fetch 완료 후에도 불일치)면 본문 대신 안내.
	if (!hasProduct) {
		return (
			<>
				{!_sn && <div className="appHeader no-border"><AppHeader title={targetSn || ''} /></div>}
				<div id="appCapsule" style={_sn ? { position: "absolute", paddingTop: "0px", width: "400px", top: (showSub ? "120px" : "60px"), right: "8px" } : {}}>
					{!fetchDone
						? <div className="section mt-2 text-center">
							<Loading />
						</div>
						: <div className="section mt-2 mb-2"><NoRecord _sn={_sn} /></div>}
				</div>
			</>
		);
	}

	return (
		<>
			{!_sn && <div className="appHeader no-border">
				<AppHeader
					title={<>{product.sn}{isDOA(product)}{isDIM(product)}</>}
					titleprefix={isOnline()}
					subtitle={product.sitename && product.sitename} />

				<div className="right">
					<a href onClick={() => setSchedule()} className="headerButton">
						<ion-icon name="calendar-outline"></ion-icon>
					</a>
					{maintab == "info" && canEditProduct && <a href onClick={() => setEditable(!editable)} className="headerButton">
						<ion-icon name="create-outline"></ion-icon>
					</a>}
					<a href onClick={() => fav()} className="headerButton">
						<ion-icon name={isFav ? "heart" : "heart-outline"}></ion-icon>
					</a>
				</div>
			</div>}
			<div id="appCapsule" style={
				_sn ? {
					position: "absolute",
					paddingTop: "0px",
					width: "400px",
					top: (showSub ? "120px" : "60px"),
					right: "8px",
				} : {}
			}>
				<div className={_sn ? "section" : "section mb-2"}>
					<ul className="nav nav-tabs style2 mt-1 mb-1"
						style={_sn && {
							boxShadow: "4px 4px 4px darkgrey"
						}}>
						{mainTabList.filter(y => _sn ? y.code != "acquisition" : y = y).map(x =>
							<li className="nav-item">
								<button key={x.code}
									className={maintab == x.code ? "nav-link active" : "nav-link"} onClick={() => { setMainTab(x.code); }}>
									{x.title}
								</button>
							</li>
						)}
					</ul>
				</div>
				{maintab == "info" &&
					<div className="" style={
						_sn ? {
							padding: 0,
							height: getScrollHeight(),
							overflowY: "auto"
						} : {}
					}>
						<ProductInfo productInfo={product} _sn={_sn} editable={editable} showsn={_sn ? true : false} cancelcallback={() => setEditable(false)} />
						{_sn && <div className="pb-1"></div>}
						{product.siteId && <div className="mb-2"><ProductInfoSite _sn={_sn} product={product} showsitename={false} /></div>}
						<div className="section mt-2 mb-2">
							<div className="card" style={_sn && {
								boxShadow: "4px 4px 4px darkgrey"
							}}>
								<ul className="nav nav-tabs lined">
									<li className="nav-item">
										<a href
											className={showDIADOA == "COMMENT" ? "nav-link active" : "nav-link"}
											onClick={() => { setshowDIADOA("COMMENT"); }} >{t('common.label.comments')}</a>
									</li>
									<li className="nav-item">
										<a href
											className={showDIADOA == "DIM" ? "nav-link active" : "nav-link"}
											onClick={() => { setshowDIADOA("DIM"); }} >{t('product.field.dim')}</a>
									</li>
									<li className="nav-item">
										<a href
											className={showDIADOA == "DOA" ? "nav-link active" : "nav-link"}
											onClick={() => { setshowDIADOA("DOA"); }} >{t('product.field.doa')}</a>
									</li>
								</ul>
								{showDIADOA == "COMMENT" && <ProductComments _sn={_sn} product={product} />}
								{showDIADOA == "DIM" && <ProductDIM _sn={_sn} product={product} />}
								{showDIADOA == "DOA" && <ProductDOA _sn={_sn} product={product} />}
							</div>
						</div>
					</div>
				}
				{maintab != "info" &&
					<div className="mt-2 mb-2">
						{maintab == "service" && <ProductInfoServices product={product} _sn={_sn} />}
						{maintab == "error" &&
							<div className="section" style={
								_sn ? {
									height: getScrollHeight(),
									overflowY: "auto"
								} : {}
							}>
								{errList.length > 0 && <>
									{errList.map(item => <ProductErrorCard item={item} key={"err" + item._id} _sn={_sn} />)}
								</>}
								{errList.length === 0 && <NoRecord title={t('common.message.noErrors')} _sn={_sn} contents={t('service.message.info.thereIsNoErrorHistory')} />}
							</div>
						}
						{/*maintab == "status" && <ProductStatus product={product} editable={editable} /> */}
						{maintab == "acquisition" && <ProductInfoACQ product={product} showtable={false} days={7} height={500} />}
					</div>
				}
			</div>
			{(_sn && showChart) &&
				<div className="card" style={
					_sn ? {
						position: "absolute",
						paddingTop: "0px",
						width: width - 36,
						opacity: 0.9,
						bottom: "18px",
						left: "18px",
						boxShadow: "4px 4px 4px darkgrey",
					} : {}
				}>
					{chartType == "acq" && <ProductInfoACQ product={product}
						showtable={false}
						days={30}
						height={300}
						onlyGraph={true} />
					}
					{chartType == "err" && <ProductInfoErrorChart product={product}
						showtable={false}
						days={60}
						height={300}
						onlyGraph={true} />
					}
				</div>
			}
			<ScheduleCreate showAS={showAS} callback={() => setShowAS(false)} />
		</>
	)
}

const mapState = (state) => {
	const productData = state.ProductReducer.product;
	const showChart = state.ProgramReducer.showChart;
	const showSub = state.ProgramReducer.showSub;
	const chartType = state.ProgramReducer.chartType;
	const favList = state.FavoriteReducer.sn;
	const user = state.AuthReducer.user;
	return { productData, favList, showChart, showSub, chartType, user };
};

const mapDispatch = dispatch => ({
	GetProduct: (sn) => dispatch(ProductAction.GetProduct(sn, { quietNotFound: true })),
	UpdateUserFav: (type, data) => dispatch(AuthAction.UpdateUserFav(type, data)),
})

export default connect(mapState, mapDispatch)(ProductView);